var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEytvFiles(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2073 14.7692H1.84683C1.68362 14.7692 1.52709 14.7043 1.41169 14.5889C1.29628 14.4735 1.23145 14.317 1.23145 14.1538V1.8461C1.23145 1.68289 1.29628 1.52636 1.41169 1.41095C1.52709 1.29555 1.68362 1.23071 1.84683 1.23071H14.1545C14.3177 1.23071 14.4743 1.29555 14.5897 1.41095C14.7051 1.52636 14.7699 1.68289 14.7699 1.8461V10.2066C14.7699 10.2874 14.754 10.3674 14.7231 10.4421C14.6921 10.5167 14.6468 10.5846 14.5897 10.6417L10.6425 14.5889C10.5853 14.6461 10.5175 14.6914 10.4428 14.7223C10.3681 14.7533 10.2881 14.7692 10.2073 14.7692V14.7692Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7141 10.4609H10.4619V14.7137",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEytvFiles);
export default __webpack_public_path__ + "static/media/eytv-files.dc76a33087c59f63efb97ccfd6eb8f82.svg";
export { ForwardRef as ReactComponent };